<template>
  <div class="knowledgeSet-container">
    <div class="filter-area">
      <el-input
        placeholder="输入知识集名称搜索"
        suffix-icon="el-icon-search"
        size="mini"
        @blur="searchFn"
        @clear="searchFn"
        v-model="formData.kbName"
        clearable
        style="width: 180px; margin-right: 10px"
      >
      </el-input>
      <el-select
        style="width: 200px;"
        v-loading="loadingC"
        v-model="formData.createName"
        size="mini"
        placeholder="选择创建人筛选"
        @change="searchFn"
        clearable
      >
        <el-option
          v-for="item in optionsCreateName"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-button
        type="primary"
        size="mini"
        @click="openPopup('add')"
        style="float: right"
        >创建知识集</el-button
      >
    </div>
    <div class="table-area" ref="tableWrapper">
      <el-table
        :height="tableHeight"
        size="medium"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        ref="singleTable"
        v-loading="loading"
        :highlight-current-row="true"
        :data="tableData"
        style="width: 100%;height:100%;font-size: 13px"
      >
        <el-table-column label="序号" width="65" align="center">
          <template slot-scope="scope">
            {{ formData.size * (formData.page - 1) + (scope.$index + 1) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="kbName"
          label="知识集名称"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="kbId"
          label="知识集ID"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column prop="status" label="状态" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" style="color: red;">停用</span>
            <span
              v-else-if="scope.row.status == 1"
              style="color: rgb(3, 177, 3);"
              >启用</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="num" label="文件数量" width="160">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="220">
        </el-table-column>
        <el-table-column prop="creatorName" label="创建人" width="160">
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="openPopup('edit', scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              style="color: orange;"
              @click="openPopup('use', scope.row)"
              v-if="scope.row.status == 0"
              >启用</el-button
            >
            <el-button
              type="text"
              style="color: red;"
              @click="deleteRow(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="staff-pagination">
      <el-pagination
        @current-change="searchFn"
        @size-change="searchFn"
        :current-page.sync="formData.page"
        :page-size.sync="formData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[20, 50, 100, 200, 500]"
      >
      </el-pagination>
    </div>

    <addEditPopup
      v-if="showAddEditPopup"
      :currentRow="rowPopup"
      :dialogVisible.sync="showAddEditPopup"
      :currentPopupType="currentPopupType"
      @getData="searchFn"
      :titleName="popupTitle"
    />
  </div>
</template>

<script>
import addEditPopup from "./addEditPopup.vue";

import dayjs from "dayjs";
import {
  delKnowledgeApi,
  knowledgeListApi,
  createNameListApi,
  KnowledStatusApi,
} from "@/api/knowledgeSet.js";
export default {
  name: "knowledgeSet",
  components: {
    addEditPopup,
  },
  data() {
    return {
      tableHeight: 500,
      optionsCreateName: [],
      loading: false,
      loadingC: false,
      formData: {
        kbName: "",
        createName: "",
        sort: "",
        asc: "",
        page: 1, //当前页码
        size: 20, //每页条数
      },
      total: 0,
      tableData: [],
      pageSizes: [10, 20, 50, 100, 200, 500],
      rowPopup: null,
      popupTitle: null,
      currentPopupType: null,
      showAddEditPopup: false,
      showAddEditPopup: false,
      /**新增 权限 */
      addPer: false,
      /**编辑/删除 权限 */
      editDelPer: false,
    };
  },
  created() {
    this.getcreateNameList();
    this.getDataList();
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        console.log("权限", newVal);
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            console.log("权限---lll", item.pname, item);
            if (item.pname == "知识集") {
              console.log("XXXXXXXX", item);
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("zsjkxj") != -1) {
                // 新增
                this.addPer = true;
              } else {
                this.addPer = false;
              }
              if (senBtnAuthority.indexOf("zsjkbs") != -1) {
                // 编辑/删除
                this.editDelPer = true;
              } else {
                this.editDelPer = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  mounted() {
    this.$nextTick(() => {
      // 动态计算父容器高度
      this.tableHeight = this.$refs.tableWrapper.clientHeight;
    });
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      const element = this.$refs.tableWrapper;
      if (element) {
        this.tableHeight = element.clientHeight;
      }
    },
    async getcreateNameList() {
      this.loadingC = true;
      const res = await createNameListApi(
        localStorage.getItem("Authorization")
      );
      this.loadingC = false;
      console.log("获取数据---1", res);
      if (res.error.code == 200) {
        res.data.forEach((v) => {
          this.optionsCreateName.push({
            value: v.id,
            label: v.creatorName,
          });
        });
      }
    },
    async getDataList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.formData));
      params.createName =
        this.optionsCreateName.find((v) => {
          return v.value == this.formData.createName;
        })?.label || "";
      const res = await knowledgeListApi(
        params,
        localStorage.getItem("Authorization")
      );
      this.loading = false;
      console.log(
        "获取表格的数据结构",
        res,
        params,
        this.optionsCreateName,
        this.formData.createName
      );
      if (res.error.code == 200) {
        res.data.records.forEach((v) => {
          if (v.createTime) {
            v.createTime = dayjs(v.createTime).format("YYYY-MM-DD HH:mm:ss");
          }
        });
        this.tableData = res.data.records;
        this.total = Number(res.data.total);
      } else {
        this.total = 0;
        this.tableData = [];
      }
    },
    searchFn() {
      this.getDataList();
    },
    /**新建  编辑 详情*/
    async openPopup(val, row) {
      this.currentPopupType = val;
      console.log("openPopup", val, row);
      switch (val) {
        case "add":
          if (!this.addPer) {
            this.$message.warning("暂无权限创建知识集");
            return;
          }
          this.popupTitle = "创建知识集";
          this.rowPopup = null;
          this.showAddEditPopup = true;
          break;
        case "edit":
          if (!this.editDelPer) {
            this.$message.warning("暂无权限编辑");
            return;
          }
          this.rowPopup = row;
          this.popupTitle = "编辑任务";
          this.showAddEditPopup = true;
          break;
        case "use":
          this.loading = true;
          const res = await KnowledStatusApi(
            { id: row.id },
            localStorage.getItem("Authorization")
          );
          this.loading = false;
          if (res.error.code == 200) {
            this.$message.success("启用成功");
            this.searchFn();
          }
          break;
        default:
          break;
      }
    },
    /**删除行 */
    deleteRow(item) {
      if (!this.editDelPer) {
        this.$message.warning("暂无权限删除");
        return;
      }
      this.$confirm(`您确定删除“${item.kbName}”？`, {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async (resk) => {
          this.loading = true;
          const res = await delKnowledgeApi(
            { kbId: item.kbId },
            localStorage.getItem("Authorization")
          );
          this.loading = false;
          console.log("删除成功", res);
          if (res.error.code == 200) {
            this.$message.success("删除成功");
            this.searchFn();
          }
        })
        .catch((action) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.knowledgeSet-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .filter-area {
    height: 40px;
  }

  .table-area {
    flex: 1;
    overflow: hidden;
  }

  .staff-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 40px;
  }
}
</style>
